(() => {
  const root = document.querySelector(".ha-quiz");
  if (!root) return;

  const form = root.querySelector("[data-quiz]");
  const screens = [...form.querySelectorAll("[data-screen]")];
  const progressFill = root.querySelector("[data-progress]");
  const stepCounter = root.querySelector("[data-step-counter]");
  const backBtn = root.querySelector("[data-back]");
  const ctaUrl = root.dataset.ctaUrl || "/collections/all";
  // Screens past the loader = the payoff. Hide quiz chrome + use brand CTA.
  const RESULT_PHASE = new Set(["summary", "map", "bridge", "result"]);
  const applyChrome = (name) =>
    root.classList.toggle("ha-quiz--result-phase", RESULT_PHASE.has(name));
  const summaryLabels = {
    age: "Age range",
    body: "How your body feels",
    symptoms: "Recent symptoms",
    stage: "Stage",
    puffiness: "Puffiness timing",
    tried: "What you've tried",
    consistency: "Supplement consistency",
    sleep: "Sleep",
    goals: "Goals",
  };

  const questionScreens = Object.keys(summaryLabels);
  const setCounter = (i) => {
    const n = questionScreens.indexOf(screens[i].dataset.screen);
    if (n >= 0) stepCounter.textContent = `${n + 1} / ${questionScreens.length}`;
  };

  const total = screens.length;
  let index = 0;
  const history = [];
  let lastFocus = ""; // primary focus area, carried from summary into the offer

  // Funnel instrumentation: GA4/Elevar (dataLayer) + Triple Whale (TriplePixel)
  // + first-party warehouse (master-dashboard beacon -> BigQuery ops_config.quiz_events)
  const BEACON_URL = "https://master-dashboard-qb1w.onrender.com/api/quiz/track";
  const UTM = (function () {
    try {
      const q = new URLSearchParams(location.search);
      const pick = (k) => (q.get(k) || "").slice(0, 120) || null;
      return {
        source: pick("utm_source"),
        medium: pick("utm_medium"),
        campaign: pick("utm_campaign"),
        content: pick("utm_content"),
        term: pick("utm_term"),
      };
    } catch (e) { return {}; }
  })();
  const sid = (function () {
    try {
      let v = sessionStorage.getItem("ha_quiz_sid");
      if (!v) {
        v = "q-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem("ha_quiz_sid", v);
      }
      return v;
    } catch (e) { return "q-" + Math.random().toString(36).slice(2, 14); }
  })();
  let beaconBuffer = [];

  function flushBeacon() {
    if (!beaconBuffer.length) return;
    const events = beaconBuffer;
    beaconBuffer = [];
    try {
      const blob = new Blob(
        [JSON.stringify({ quiz: "longevity", session_id: sid, events: events, utm: UTM })],
        { type: "text/plain" } // simple request: no CORS preflight
      );
      if (navigator.sendBeacon) navigator.sendBeacon(BEACON_URL, blob);
    } catch (e) { /* never break the quiz */ }
  }

  function track(event, data) {
    try {
      const payload = Object.assign({ quiz: "longevity" }, data || {});
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: event }, payload));
      }
      if (typeof window.TriplePixel === "function") {
        window.TriplePixel("custom", event, payload);
      }
      beaconBuffer.push(Object.assign({ event: event, ts: Date.now() }, data || {}));
      if (
        beaconBuffer.length >= 12 ||
        event === "quiz_complete" ||
        event === "quiz_cta_click"
      ) {
        flushBeacon();
      }
    } catch (e) { /* analytics must never break the quiz */ }
  }

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") flushBeacon();
  });
  window.addEventListener("pagehide", flushBeacon);

  let lastStepAt = 0;
  function setStep(next, push = true) {
    lastStepAt = Date.now();
    if (next < 0 || next >= screens.length) return;
    hideNudge();
    if (push && next !== index) history.push(index);
    screens[index].classList.remove("is-active");
    index = next;
    const screen = screens[index];
    screen.classList.add("is-active");

    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    setCounter(index);
    backBtn.hidden = history.length === 0;

    window.scrollTo({ top: 0, behavior: "smooth" });

    const screenName = screen.dataset.screen;
    applyChrome(screenName);
    location.hash = screenName;
    track("quiz_step", { step: screenName, index: index + 1, total: total });

    if (screenName.indexOf("loader") === 0) runLoader(screen);
    if (screenName === "trust") initCarousel(screen);
    if (screenName === "summary") renderSummary(screen);
    if (screenName === "map") renderMap(screen);
    if (screenName === "bridge") renderBridge(screen);
    if (screenName === "result") {
      const focusEl = screen.querySelector("[data-offer-focus]");
      if (focusEl && lastFocus) {
        focusEl.textContent = "Your #1 focus: " + lastFocus;
        focusEl.hidden = false;
      }
      const cta = screen.querySelector("[data-cta]");
      if (cta) {
        cta.href = ctaUrl;
        if (!cta.dataset.trackBound) {
          cta.dataset.trackBound = "1";
          cta.addEventListener("click", function () {
            track("quiz_cta_click", { step: "result" });
          });
        }
      }
    }

    setTimeout(() => {
      const firstInput = screen.querySelector("input");
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 50);
  }

  function isAnswered(screen) {
    if (!screen.hasAttribute("data-required")) return true;
    const inputs = screen.querySelectorAll("input[type=radio], input[type=checkbox]");
    return [...inputs].some((i) => i.checked);
  }

  // visible feedback when Continue is tapped with nothing selected
  // (the 6px button shake alone goes unnoticed on mobile)
  let nudge;
  function showNudge() {
    if (!nudge) {
      nudge = document.createElement("p");
      nudge.className = "ha-quiz__nudge";
      nudge.setAttribute("role", "alert");
      nudge.textContent = "Select an answer to continue";
      form.appendChild(nudge);
    }
    nudge.classList.add("is-on");
  }
  function hideNudge() {
    if (nudge) nudge.classList.remove("is-on");
  }

  function runLoader(screen) {
    const items = [...screen.querySelectorAll("[data-step]")];
    const ms = parseInt(screen.dataset.autoAdvance || "4500", 10);
    const each = Math.max(400, Math.floor(ms / items.length));
    items.forEach((it) => it.classList.remove("is-active", "is-done"));
    items.forEach((item, i) => {
      setTimeout(() => {
        items.forEach((x) => x.classList.remove("is-active"));
        item.classList.add("is-active");
        if (i > 0) items[i - 1].classList.add("is-done");
      }, each * i);
    });
    setTimeout(() => {
      items.forEach((x) => x.classList.remove("is-active"));
      items.forEach((x) => x.classList.add("is-done"));
      setStep(index + 1);
    }, each * items.length);
  }

  function getAnswers() {
    const data = new FormData(form);
    const out = {};
    for (const [k, v] of data.entries()) {
      if (out[k] === undefined) out[k] = v;
      else if (Array.isArray(out[k])) out[k].push(v);
      else out[k] = [out[k], v];
    }
    return out;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  }

  function listPhrase(a) {
    if (!a.length) return "the changes you described";
    if (a.length === 1) return a[0];
    if (a.length === 2) return a[0] + " and " + a[1];
    return a.slice(0, -1).join(", ") + ", and " + a[a.length - 1];
  }

  // Map each pain the user actually reports to what the formula does about it.
  // Plain, honest, and only triggered by answers they marked (no invented claims).
  function buildInsights(answers) {
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const sleep = answers.sleep || "";
    const body = answers.body || "";
    const stage = answers.stage || "";
    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));

    const catalog = [
      {
        on: body.indexOf("Energy") > -1 || symHas("afternoon") || goalHas("energy"),
        pain: symHas("afternoon") ? "Your energy crashes in the afternoon" : "Your energy isn't what it used to be",
        action: "NAD+ precursors, CoQ10, and PQQ fuel your mitochondria, so the afternoon dip fades and you stay even all day.",
        tone: "#e6c389", icon: "M13 2L3 14h7l-1 8 10-12h-7l1-8z",
      },
      {
        on: sleep.indexOf("Wakes") > -1 || sleep.indexOf("Trouble") > -1 || sleep.indexOf("tired") > -1 || goalHas("sleep"),
        pain: sleep.indexOf("Wakes") > -1 ? "You wake up between 2 and 4am" : (sleep.indexOf("tired") > -1 ? "You sleep, but wake up tired" : "Your sleep doesn't leave you rested"),
        action: "L-theanine plus the NAD+-powered repair your cells run overnight help rest go deeper, so you wake up clearer.",
        tone: "#a1add8", icon: "M21 13a9 9 0 11-7.5-8.86A7 7 0 0021 13z",
      },
      {
        on: symHas("puffiness") || symHas("bloating") || symHas("water") || goalHas("puffy") || goalHas("digestion"),
        pain: symHas("bloating") ? "You bloat after normal meals" : "You feel puffy and swollen",
        action: "Organic antioxidants and circulation support help you feel lighter and less swollen.",
        tone: "#9caf88", icon: "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z",
      },
      {
        on: symHas("mood") || stage === "Perimenopause" || stage === "Menopause" || stage === "Postmenopause" || goalHas("stress"),
        pain: (stage === "Perimenopause" || stage === "Menopause" || stage === "Postmenopause") ? "Your hormones are shifting" : "Your mood swings and feels off",
        action: "Maca and chaste berry (Vitex) support a steadier mood through the hormonal shift.",
        tone: "#da9897", icon: "M3 12c3-4 5-4 8 0s5 4 8 0",
      },
      {
        on: symHas("weight") || symHas("waistline") || goalHas("weight"),
        pain: "Weight that won't move and a softer waistline",
        action: "Resveratrol and metabolic support help your effort start to show as your hormones change.",
        tone: "#d0535b", icon: "M4 14l5-5 4 4 6-7",
      },
      {
        on: symHas("skin") || goalHas("skin"),
        pain: "Your skin is looking more tired",
        action: "Hyaluronic acid, grape seed, and vitamin C support skin hydration, firmness, and glow.",
        tone: "#c98a86", icon: "M12 2l2.2 6.6L21 11l-6.8 2.4L12 20l-2.2-6.6L3 11l6.8-2.4z",
      },
    ];
    return catalog.filter((c) => c.on);
  }

  function renderMap(screen) {
    const answers = getAnswers();
    let insights = buildInsights(answers);
    if (insights.length < 2) {
      const fallback = [
        { pain: "After 30, your cellular energy dips", action: "NAD+ helps your cells make energy again. Everything else builds on it.", tone: "#e6c389", icon: "M13 2L3 14h7l-1 8 10-12h-7l1-8z" },
        { pain: "Daily wear and tear adds up over time", action: "Consistent daily NAD+ support helps your body repair and recover, day after day.", tone: "#9caf88", icon: "M12 2l8 4v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-4z" },
      ];
      fallback.forEach((f) => { if (insights.length < 2) insights.push(f); });
    }
    insights = insights.slice(0, 4);
    const list = screen.querySelector("[data-map-list]");
    if (!list) return;
    list.innerHTML = insights
      .map(
        (i) =>
          '<li class="ha-map__row" style="--tone:' + (i.tone || "#9caf88") + '">' +
          '<span class="ha-map__icon" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 24 24" fill="none"><path d="' + (i.icon || "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z") + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<div class="ha-map__body">' +
          '<p class="ha-map__pain">' + escapeHtml(i.pain) + "</p>" +
          '<p class="ha-map__action"><span class="ha-map__arrow" aria-hidden="true">→</span>' + escapeHtml(i.action) + "</p>" +
          "</div>" +
          "</li>"
      )
      .join("");
  }

  function renderSummary(screen) {
    const answers = getAnswers();
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);

    // Subscores 0-100 (higher = better support)
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const sleep = answers.sleep || "";
    const tried = answers.tried || "";
    const consistency = answers.consistency || "";
    const body = answers.body || "";
    const puffiness = answers.puffiness || "";

    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));

    // Cellular energy & NAD+
    let energy = 70;
    if (body.includes("Energy")) energy -= 25;
    if (symHas("afternoon")) energy -= 20;
    if (sleep.includes("tired") || sleep.includes("Trouble")) energy -= 15;
    if (sleep === "Solid") energy += 10;
    if (goalHas("energy")) energy -= 5;

    // Hormonal balance
    let bodyScore = 70;
    const stage = answers.stage || "";
    if (stage === "Perimenopause") bodyScore -= 18;
    else if (stage === "Menopause" || stage === "Postmenopause") bodyScore -= 25;
    if (symHas("mood") || symHas("waistline") || symHas("weight")) bodyScore -= 15;
    if (puffiness === "Around cycle") bodyScore -= 10;
    if (tried.includes("Hormone")) bodyScore -= 5;

    // Sleep & recovery
    let digestion = 70;
    if (sleep.includes("Wakes") || sleep.includes("Trouble") || sleep.includes("tired")) digestion -= 28;
    if (sleep === "Solid") digestion += 12;
    if (sleep === "Depends") digestion -= 10;
    if (goalHas("sleep")) digestion -= 8;

    // Inflammation & puffiness
    let micro = 70;
    if (symHas("puffiness") || symHas("bloating")) micro -= 28;
    if (consistency.includes("Forget") || consistency === "Hit or miss") micro -= 12;
    if (tried === "Nothing yet") micro -= 12;
    if (puffiness === "Morning" || puffiness === "After meals") micro -= 8;

    const clamp = (n) => Math.max(8, Math.min(95, Math.round(n)));
    energy = clamp(energy);
    bodyScore = clamp(bodyScore);
    digestion = clamp(digestion);
    micro = clamp(micro);

    const overall = Math.round((energy + bodyScore + digestion + micro) / 4);

    const labelFor = (n) =>
      n < 30 ? "Low" :
      n < 55 ? "Fair" :
      n < 75 ? "Good" :
      "Strong";

    const badgeFor = (n) =>
      n < 25 ? "LOW" :
      n < 50 ? "LOW-MODERATE" :
      n < 70 ? "MODERATE" :
      n < 85 ? "GOOD" :
      "HIGH";

    screen.querySelector("[data-result-badge]").textContent = badgeFor(overall);
    const fill = screen.querySelector("[data-gauge-fill]");
    const marker = screen.querySelector("[data-gauge-marker]");
    if (fill) fill.style.width = overall + "%";
    if (marker) marker.style.left = overall + "%";

    // Each system card: short status word + a visual level meter (low = amber)
    const applyCard = (cardKey, meterKey, n) => {
      const val = screen.querySelector("[data-card='" + cardKey + "']");
      if (val) { val.textContent = labelFor(n); val.classList.toggle("ha-result__card-value--low", n < 40); }
      const fillEl = screen.querySelector("[data-meter='" + meterKey + "']");
      if (fillEl) { fillEl.style.width = Math.max(6, n) + "%"; fillEl.classList.toggle("ha-result__meter-fill--low", n < 40); }
    };
    applyCard("energy", "energy", energy);
    applyCard("body", "body", bodyScore);
    applyCard("digestion", "digestion", digestion);
    applyCard("micronutrients", "micro", micro);

    // Primary focus area = the weakest subscore (the root cause to address first)
    const focusMap = { energy: "Cellular energy & NAD+", body: "Hormonal balance", digestion: "Sleep & recovery", micro: "Inflammation & puffiness", skin: "Skin & healthy aging" };
    const subs = { energy: energy, body: bodyScore, digestion: digestion, micro: micro };
    const weakest = Object.keys(subs).reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    const focusEl = screen.querySelector("[data-primary-focus]");

    // Link the plan AND the primary focus to her stated GOALS. Falls back to the
    // weakest scored system if somehow no goals were marked.
    const goalMap = {
      "Feel less puffy": { sys: "micro", phrase: "feel less puffy" },
      "Reduce stress": { sys: "digestion", phrase: "reduce stress" },
      "Steadier energy": { sys: "energy", phrase: "steadier energy" },
      "Better digestion": { sys: "micro", phrase: "better digestion" },
      "Skin and healthy aging": { sys: "skin", phrase: "support your skin" },
      "Weight management": { sys: "body", phrase: "manage your weight" },
      "Sleep better": { sys: "digestion", phrase: "sleep better" },
      // merged 5-option labels (2026-08-19)
      "Feel less puffy and better digestion": { sys: "micro", phrase: "feel less puffy" },
      "Sleep better and reduce stress": { sys: "digestion", phrase: "sleep better" },
    };
    const goalList = arr("goals");
    const goalSystems = {};
    const goalPhrases = [];
    goalList.forEach((g) => {
      const m = goalMap[g];
      if (m) { goalSystems[m.sys] = true; if (goalPhrases.indexOf(m.phrase) === -1) goalPhrases.push(m.phrase); }
    });
    const hasGoals = goalPhrases.length > 0;

    // Primary focus = the goal area that needs the most support today
    // (weakest scored system among her goals).
    const scoredGoals = Object.keys(goalSystems).filter((s) => subs[s] !== undefined);
    let focusKey = weakest;
    if (scoredGoals.length) focusKey = scoredGoals.reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    else if (goalSystems.skin) focusKey = "skin";
    if (focusEl) focusEl.textContent = focusMap[focusKey];
    lastFocus = focusMap[focusKey];

    // Secondary focus: the next weakest system after the primary one. Rendered
    // only where the markup exists, so the sections that share this file and do
    // not have the element are untouched.
    const secWrap = screen.querySelector("[data-secondary-wrap]");
    const secEl = screen.querySelector("[data-secondary-focus]");
    if (secWrap && secEl) {
      const pool = (scoredGoals.length ? scoredGoals : Object.keys(subs)).filter((k) => k !== focusKey);
      if (pool.length) {
        const second = pool.reduce((a2, b2) => (subs[a2] <= subs[b2] ? a2 : b2));
        secEl.textContent = focusMap[second];
        secWrap.hidden = false;
      } else {
        secWrap.hidden = true;
      }
    }

    // Name the exact signals that drove the primary focus (answers -> result).
    const driverMap = {
      energy: function () {
        const d = [];
        if (body.indexOf("Energy") > -1) d.push("lower energy");
        if (symHas("afternoon")) d.push("afternoon crashes");
        if (sleep.indexOf("tired") > -1 || sleep.indexOf("Trouble") > -1 || sleep.indexOf("Wakes") > -1) d.push("restless sleep");
        if (goalHas("energy")) d.push("wanting steadier energy");
        return d;
      },
      body: function () {
        const d = [];
        if (stage === "Perimenopause" || stage === "Menopause" || stage === "Postmenopause") d.push("your hormonal stage");
        if (symHas("mood")) d.push("mood swings");
        if (symHas("waistline") || symHas("weight")) d.push("changes around your waistline");
        if (goalHas("weight")) d.push("wanting to manage your weight");
        return d;
      },
      digestion: function () {
        const d = [];
        if (sleep.indexOf("Wakes") > -1) d.push("waking at 2 to 4am");
        else if (sleep.indexOf("tired") > -1) d.push("waking up tired");
        else if (sleep.indexOf("Trouble") > -1) d.push("trouble falling asleep");
        if (goalHas("sleep")) d.push("wanting to sleep better");
        return d;
      },
      micro: function () {
        const d = [];
        if (symHas("puffiness")) d.push("puffiness");
        if (symHas("bloating")) d.push("bloating");
        if (goalHas("puffy") || goalHas("digestion")) d.push("wanting to feel less puffy");
        return d;
      },
      skin: function () {
        const d = [];
        if (symHas("skin")) d.push("tired-looking skin");
        if (goalHas("skin")) d.push("wanting to support your skin");
        return d;
      },
    };
    const drivers = (driverMap[focusKey] ? driverMap[focusKey]() : [])
      .filter(function (v, i, a) { return a.indexOf(v) === i; }).slice(0, 3);
    const becauseEl = screen.querySelector("[data-focus-because]");
    if (becauseEl && drivers.length) becauseEl.textContent = " (you flagged " + listPhrase(drivers) + ")";

    // Personalized objection line from what she has already tried.
    const triedMap = {
      "NAD+ supplements": "You've tried NAD+ before. Single-pathway boosters fade because they feed only one route. This one feeds four.",
      "Hormone support": "You've tried hormone support. This adds the cellular energy layer (NAD+) that hormone-only formulas miss.",
      "Greens or probiotics": "Greens and probiotics cover the gut. This covers what they don't: cellular energy, skin, and hormonal balance.",
      "Collagen or skin": "Collagen works from the outside in. This feeds the cells that build collagen from the inside.",
      "Diet and exercise": "Diet and exercise set the base. NAD+ is the cellular fuel they can't replace after 40.",
      "GLP-1 or weight medication": "On a GLP-1, protecting lean muscle, skin, and energy matters most. That's what this supports.",
      "Nothing yet": "Starting fresh is the best time. Consistency from day one is what compounds.",
    };
    const triedEl = screen.querySelector("[data-tried-line]");
    if (triedEl && triedMap[tried]) { triedEl.textContent = triedMap[tried]; triedEl.hidden = false; }

    screen.querySelectorAll("[data-blend-system]").forEach((el) => {
      const match = hasGoals ? !!goalSystems[el.dataset.blendSystem] : el.dataset.blendSystem === weakest;
      el.classList.toggle("ha-plan__blend--focus", match);
      const tag = el.querySelector("[data-blend-tag]");
      if (tag) tag.hidden = !match;
    });
    const leadEl = screen.querySelector(".ha-plan__lead");
    if (leadEl && hasGoals) {
      leadEl.innerHTML = "You want to <strong>" + escapeHtml(listPhrase(goalPhrases.slice(0, 3))) + "</strong>. This plan targets it.";
    }

    // Build a phrase from the symptoms they actually marked, so the copy mirrors them.
    const shortMap = {
      "Puffiness or water retention": "puffiness",
      "Bloating after normal meals": "bloating",
      "Weight that will not move": "stubborn weight",
      "Softer waistline": "a softer waistline",
      "Afternoon energy crashes": "afternoon energy crashes",
      "Mood swings or irritability": "mood swings",
      "Skin looking more tired": "tired-looking skin",
    };
    const reported = symptoms.map((s) => shortMap[s] || s.toLowerCase()).slice(0, 3);
    if (reported.length < 2) {
      if ((sleep.indexOf("Wakes") > -1 || sleep.indexOf("tired") > -1) && reported.indexOf("restless sleep") === -1) reported.push("restless sleep");
      if (body.indexOf("Energy") > -1 && reported.indexOf("afternoon energy crashes") === -1 && reported.indexOf("lower energy") === -1) reported.push("lower energy");
    }
    const hasReported = reported.length > 0;
    const reportedPhrase = listPhrase(reported);

    // Show her own reported signals back as chips, so the result reads as hers.
    const chipsWrap = screen.querySelector("[data-reported-chips]");
    const reportedBox = screen.querySelector("[data-reported]");
    if (chipsWrap && reported.length) {
      chipsWrap.innerHTML = reported
        .map(function (t) { return '<span class="ha-result__chip">' + escapeHtml(t) + "</span>"; })
        .join("");
      if (reportedBox) reportedBox.hidden = false;
    }

    // Personalize alert copy — names the signals they reported, score sets the tone.
    const title = screen.querySelector("[data-alert-title]");
    const copy = screen.querySelector("[data-alert-copy]");
    if (overall < 50) {
      title.textContent = "Your cells need more consistent support.";
      copy.textContent = hasReported
        ? "We trace " + reportedPhrase + " back to NAD+ declining with age."
        : "These signals point to NAD+ declining with age.";
    } else if (overall < 75) {
      title.textContent = "You're doing well, with room to feel even better.";
      copy.textContent = "Targeted daily support can lift your energy and resilience within weeks.";
    } else {
      title.textContent = "You're in a strong place.";
      copy.textContent = "Consistent daily support keeps the energy and clarity you've built.";
    }

    try {
      sessionStorage.setItem(
        "ha_quiz_answers",
        JSON.stringify({ answers, focus: lastFocus, badge: badgeFor(overall), scores: { overall, energy, body: bodyScore, digestion, micro } })
      );
    } catch (e) {}

    track("quiz_complete", {
      score: overall,
      badge: badgeFor(overall),
      focus: focusMap[weakest],
    });
  }

  // Projection: stamp a personalized ~12-week date on the bridge screen
  function renderBridge(screen) {
    const el = screen.querySelector("[data-projection-date]");
    if (!el) return;
    const d = new Date();
    d.setDate(d.getDate() + 84);
    el.textContent = d.toLocaleDateString("en-US", { month: "long", day: "numeric" });
  }

  // Carousel
  function initCarousel(screen) {
    const car = screen.querySelector("[data-carousel]");
    if (!car || car.dataset.inited === "1") return;
    car.dataset.inited = "1";
    const track = car.querySelector("[data-track]");
    const slides = track.children;
    const dots = [...car.querySelectorAll("[data-dot]")];
    const prev = car.querySelector("[data-prev]");
    const next = car.querySelector("[data-next-slide]");
    const autoplayMs = parseInt(car.dataset.autoplay || "0", 10);
    let i = 0;
    let timer = null;

    const render = () => {
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    };
    const go = (delta) => {
      i = (i + delta + slides.length) % slides.length;
      render();
      restart();
    };
    const restart = () => {
      if (!autoplayMs) return;
      clearInterval(timer);
      timer = setInterval(() => go(1), autoplayMs);
    };
    prev.addEventListener("click", (e) => { e.stopPropagation(); go(-1); });
    next.addEventListener("click", (e) => { e.stopPropagation(); go(1); });
    dots.forEach((d, idx) => d.addEventListener("click", (e) => { e.stopPropagation(); i = idx; render(); restart(); }));

    // touch swipe
    let startX = 0;
    track.addEventListener("touchstart", (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });

    render();
    restart();
  }

  // wire up "next" buttons
  form.addEventListener("click", (e) => {
    const next = e.target.closest("[data-next]");
    if (!next) return;
    e.preventDefault();
    const screen = screens[index];
    if (!isAnswered(screen)) {
      // ghost tap: finger was already coming down when the radio auto-advanced
      if (Date.now() - lastStepAt < 400) return;
      next.animate(
        [
          { transform: "translateX(0)" },
          { transform: "translateX(-6px)" },
          { transform: "translateX(6px)" },
          { transform: "translateX(0)" },
        ],
        { duration: 240 }
      );
      showNudge();
      return;
    }
    hideNudge();
    setStep(index + 1);
  });

  // text inputs (name): Enter advances instead of implicitly submitting + reloading the quiz
  form.addEventListener("submit", (e) => e.preventDefault());
  form.addEventListener("keydown", (e) => {
    if (e.key !== "Enter") return;
    const t = e.target;
    if (t.tagName !== "INPUT" || t.type !== "text") return;
    e.preventDefault();
    const btn = screens[index].querySelector("[data-next]");
    if (btn) btn.click();
  });

  // auto-advance for radio (single-select), not checkbox
  form.addEventListener("change", (e) => {
    const screen = screens[index];
    if (e.target.type === "radio" || e.target.type === "checkbox") {
      hideNudge();
      track("quiz_answer", {
        question: e.target.name,
        value: e.target.value,
        checked: e.target.checked !== false,
      });
    }
    if (e.target.type !== "radio") return;
    if (screen.hasAttribute("data-multi")) return;
    const at = index;
    setTimeout(() => { if (index === at) setStep(index + 1); }, 220);
  });

  // back
  backBtn.addEventListener("click", () => {
    if (!history.length) return;
    const prev = history.pop();
    screens[index].classList.remove("is-active");
    index = prev;
    screens[index].classList.add("is-active");
    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    setCounter(index);
    backBtn.hidden = history.length === 0;
    applyChrome(screens[index].dataset.screen);
    window.scrollTo({ top: 0, behavior: "smooth" });
    location.hash = screens[index].dataset.screen;
  });

  // initial
  progressFill.style.width = `${Math.round((1 / total) * 100)}%`;
  setCounter(0);
  track("quiz_view", { step: "age", index: 1, total: total });

  // July 4th urgency: live countdown to end of day on the offer screen.
  (function () {
    var el = root.querySelector("[data-j4-countdown]");
    if (!el) return;
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(23, 59, 59, 999);
      var ms = Math.max(0, end - now);
      var h = Math.floor(ms / 3600000), m = Math.floor(ms / 60000) % 60, sec = Math.floor(ms / 1000) % 60;
      el.textContent = (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m) + ":" + (sec < 10 ? "0" + sec : sec);
    }
    tick();
    setInterval(tick, 1000);
  })();

  // The global Rebuy app embed auto-opens SmartCart on hydration. CSS hides its
  // flyout on the quiz; this also calls hide() so any scroll-lock is released.
  // Scoped: this file only runs on the quiz. Belt-and-suspenders, low cost.
  function closeRebuy() {
    try { if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.hide === "function") Rebuy.SmartCart.hide(); } catch (e) {}
  }
  document.addEventListener("rebuy.ready", closeRebuy);
  [800, 2000, 4000, 7000].forEach(function (t) { setTimeout(closeRebuy, t); });
})();
